<div class="steps">
  @for (item of stepsData; track item) {
    <div
      class="step"
      [ngClass]="{ active: item === step }"
    ></div>
  }
</div>
